import ModalContainer from "../../containers/Modal/ModalContainer";
import { useUserContext } from "./UserContext";
import { useTranslation } from "react-i18next";

import "../styles/forms.scss";
import { DropDownMultiCheck } from "../Interview/AdvanceSearch/DropDownMultiCheck";

const UserForm = () => {
  const { t } = useTranslation();
  const {
    showForm,
    onCloseForm,
    user,
    onChange,
    errors,
    errorSummary,
    onSubmitUser,
    roles,
    setRoles,
    setCompanyRoles,
    superVisorList
  } = useUserContext();

  return (
    <ModalContainer
      modalTitle={user.id ? t("Update user") : t("Add new user")}
      isOpen={showForm}
      closeModal={onCloseForm}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onCloseForm}
      submitButtonTitle={t("Save")}
      submitButtonAction={onSubmitUser}
    >
      <>
        <form>
          {errorSummary.length > 0 && (
            <div className="alert alert-danger">{errorSummary}</div>
          )}

          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("User Name")}</label>
              {errors.userName && (
                <span className="error-msg">{errors.userName}</span>
              )}
            </div>
            <input
              type="text"
              className="input-field"
              id="userName"
              name="userName"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={user.userName}
              disabled={user.id}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Full Name")}</label>
              {errors.fullName && (
                <span className="error-msg">{errors.fullName}</span>
              )}
            </div>
            <input
              type="text"
              className="input-field"
              id="userName"
              name="fullName"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={user.fullName}
              disabled={user.id}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <strong>{t("Nickname")}</strong>
            </div>
            <input
              type="text"
              className="input-field"
              id="nickname"
              name="nickname"
              aria-describedby="initials"
              onChange={onChange}
              value={user.nickname}
              disabled={user.id}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <strong>{t("Initials")}</strong>
            </div>
            <input
              type="text"
              className="input-field"
              id="initials"
              name="initials"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={user.initials}
              disabled={user.id}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("Email Address")}</label>
              {errors.email && (
                <span className="error-msg">{errors.email}</span>
              )}
            </div>
            <input
              type="text"
              className="input-field"
              id="email"
              name="email"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={user.email}
              disabled={user.id}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label>
                <strong>{t("Profile")}</strong>
              </label>
              {errors.roleId && (
                <span className="error-msg">{errors.roleId}</span>
              )}
            </div>

            <DropDownMultiCheck
              dataList={roles}
              selecteds={user ? user.roles : []}
              setSelecteds={setRoles}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label>
                <strong>{t("Company Profile")}</strong>
              </label>
            </div>
            <DropDownMultiCheck
              dataList={roles}
              selecteds={user.companyRoles || []}
              setSelecteds={setCompanyRoles}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label>
                <strong>{t("Report to")}</strong>
              </label>
            </div>
            <select
              name="supervisorId"
              id="supervisorId"
              className="form-control"
              value={user.supervisorId}
              onChange={onChange}
            >
              <option value="0">Select</option>
              {superVisorList.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.nickname}
                </option>
              ))}
            </select>
          </div>
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="active"
              name="active"
              onChange={onChange}
              checked={user.active}
            />
            <label className="form-check-label" htmlFor="#active">
              {t("Active")}
            </label>
          </div>
        </form>
      </>
    </ModalContainer>
  );
};

export default UserForm;
